/**
 * SiteLayout.tsx — Shell do site institucional Nectaris
 * Wrapper com .ns-site (tokens Claude Design), Nav e Footer embutido nas páginas
 * Fiel ao Claude Design: light background, sem dark shell
 * ADR-009: tokens .ns-site em src/index.css
 *
 * ORB-SITE-002: monta useNectarisFx uma única vez (reveal/parallax/spin)
 * via componente interno FxMount para garantir que o hook rode no tree React
 * mas com escopo no document inteiro — idêntico ao comportamento do script original.
 */

import { Outlet } from "react-router";
import { Nav } from "./Nav";
import { useNectarisFx } from "./useNectarisFx";
import "./site-institucional.css";

/** Componente interno que monta o hook de animações; sem renderização extra. */
function FxMount() {
  useNectarisFx();
  return null;
}

export function SiteLayout() {
  return (
    <div className="ns-site">
      <FxMount />
      <Nav />
      <main id="main-content">
        <Outlet />
      </main>
    </div>
  );
}
